<div style="margin-bottom: 15px;">
  <h1 class="cpo-page-header-title" (click)="btnClick()">{{ text }}</h1>
</div>
